module.exports = __webpack_public_path__ + "static/media/religare_icn_landing_card_3.41b7963b.png";